/**
 * @generated SignedSource<<8ec0877dc622e8daa23b9623ee834a22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CampaignInputInfluencer$data = {
  readonly linkingInstagram: boolean | null;
  readonly linkingTiktok: boolean | null;
  readonly linkingTwitter: boolean | null;
  readonly profile: {
    readonly tiktokUrl: string | null;
    readonly ytChannel: string | null;
  };
  readonly tiktokOauthEnabled: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"CampaignInputAddressInfluencer" | "CampaignInputCategoryCategories" | "CampaignInputEmailConfirmEmail" | "CampaignInputInvoiceInfluencer" | "CampaignInputProfileInfluencer" | "CampaignInputSnsInfluencer" | "requirementForApplyInfluencer">;
  readonly " $fragmentType": "CampaignInputInfluencer";
};
export type CampaignInputInfluencer$key = {
  readonly " $data"?: CampaignInputInfluencer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CampaignInputInfluencer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CampaignInputInfluencer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkingInstagram",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkingTwitter",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkingTiktok",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tiktokOauthEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InfluencerInfo",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tiktokUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ytChannel",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CampaignInputProfileInfluencer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CampaignInputSnsInfluencer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CampaignInputAddressInfluencer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CampaignInputCategoryCategories"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CampaignInputEmailConfirmEmail"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CampaignInputInvoiceInfluencer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "requirementForApplyInfluencer"
    }
  ],
  "type": "Influencer",
  "abstractKey": null
};

(node as any).hash = "d8d80ccac965a03c724a8f5f9d696fcb";

export default node;
